import {
  Build as build,
  Create as create,
  Dev as dev,
  Init as init,
  Serve as serve,
} from './commands/index.js'

export const COMMANDS = {
  build,
  create,
  dev,
  init,
  serve,
}
